<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div>
      <div class="uk-flex uk-flex-between uk-flex-middle">
        <div>
          <h1 class="uk-h4 uk-margin-remove">
            <span data-uk-icon="icon:question; ratio:1.2"></span>
            FAQ`s
          </h1>
        </div>
        <div>
          <a @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
            <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
            Zurück
          </a>
        </div>
      </div>
    </div>
    <div>
      <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
        <div class="uk-card-body">
          <ul uk-accordion>
            <li>
              <a class="uk-accordion-title" href="#">Allgemeine Hilfe</a>
              <div class="uk-accordion-content">
                <p>
                  Sobald Sie ein Fahrzeug im Warenkorb hinterlegt haben, bleibt dieses drei Stunden für Kunden
                  reserviert.
                </p>
                <p>
                  Der Wechsel in die "Endkundenansicht" ermöglicht Ihnen, Ihre Marge selbst festzulegen. Die Kunden
                  werden keinen Zugriff auf Ihren Einkaufspreis haben und lediglich den Kaufpreis sehen.
                </p>
                <p class="uk-text-bold">
                  Wechsel zur Kundenansicht:
                </p>
                <div class="uk-background-muted uk-padding uk-border-rounded" style="border: 1px solid #ccc">
                  <img src="/img/faq/kundenansicht-fleetpool.png" alt="" />
                </div>
                <p class="uk-text-bold">
                  Marge eingeben:
                </p>
                <div class="uk-background-muted uk-padding uk-border-rounded" style="border: 1px solid #ccc">
                  <img src="/img/faq/marge-fleetpool.png" alt="" />
                </div>
                <p>
                  Ist Ihre Bestellung erfolgreich abgeschlossen, werden Ihnen sowohl der akzeptierte Bestellschein, als
                  auch alle Rechnungen zugesandt.
                </p>
              </div>
            </li>
            <li>
              <a class="uk-accordion-title" href="#">Reklamationsprozess</a>
              <div class="uk-accordion-content">
                <div class="uk-h3">
                  Reklamationsbearbeitung <br />
                  Meldung von Transportschäden & verdeckten Schäden
                </div>
                <p class="uk-text-bold">
                  Fahrzeugprüfung:
                </p>
                <ul class="uk-list uk-list-disc">
                  <li>
                    Prüfen Sie den Zustand erworbener Gebrauchtwagen vor jeder Anlieferung und vergleichen Sie diesen
                    anschließend mit dem Zustandsbericht (des TÜVs Rheinland). Der Zustandsbericht lag Ihrem
                    Bestellschein bei.
                  </li>
                  <li>
                    Vermerken Sie Schäden und Fehlteile auf dem Lieferschein. Der Lieferschein muss danach vom Spediteur
                    unterschrieben werden.
                  </li>
                  <li>
                    Melden Sie sämtliche Abweichungen innerhalb eines Zeitraums von 24 Stunden.
                  </li>
                  <li>
                    Sollten Sie sich für eine persönliche Selbstabholung, oder eine Selbstabholung durch Dritte, an
                    einem der Lagerparks entschieden haben, sind Sie in diesem Fall dazu verpflichtet, Schäden oder
                    Fehlteile auf der Übernahmebescheinigung zu vermerken. Die Lagerparks müssen Ihre
                    Übernahmebescheinigung mit Stempel und Unterschrift bestätigen. Auch sollten Sie den Zustandsbericht
                    bei der Abholung immer mit sich führen.
                  </li>
                  <li>
                    Im Falle einer Nachtanlieferung sind Schäden oder Fehlteile bis spätestens 12:00 Uhr des Folgetags
                    zu melden.
                  </li>
                  <li>
                    Eine eventuelle Haftbarmachung der Spediteure ist ausschließlich unter Einhaltung der
                    vorausgegangenen Prozesse möglich.
                  </li>
                  <li>
                    Meldungen können an folgende E-Mail Adresse gesendet werden:
                    <a href="mailto:dispo-remarketing@fleetpool.de">dispo-remarketing@fleetpool.de</a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
